import React from 'react';
import { FacebookIcon, TwitterIcon, InstagramIcon, LinkedinIcon, MailIcon, PhoneIcon, MapPinIcon } from 'lucide-react';
import { Logo } from './Logo';
export function Footer() {
  return <footer className="bg-gray-950 text-gray-300 pt-16 pb-8 border-t border-gray-800" data-id="element-27" data-mp="32onj8zjvni7d">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-28" data-mp="36oxzd51dvozy">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-29" data-mp="36nd75m2jki59">
          {/* Company Info */}
          <div className="lg:col-span-1" data-id="element-30" data-mp="38qu4u3bljp2">
            <a href="#" className="inline-flex items-center mb-6 rounded-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-red-600 focus-visible:ring-offset-4 focus-visible:ring-offset-gray-950" data-id="element-31" data-mp="37o2ul235f8m">
              <Logo variant="dark" size="sm" data-id="element-32" data-mp="29z6tk9nn6feu" />
            </a>
            <p className="text-gray-400 mb-6 text-sm leading-relaxed" data-id="element-33" data-mp="29xlzsm95j0i1">
              Marketing Experts at Driving & Turning Traffic into Conversions
              with a Focus on Building Customer Loyalty & Retention.
            </p>
            <div className="space-y-3 text-sm" data-id="element-34" data-mp="3lbdaunotrzj6">
              <a href="tel:17022134801" className="flex items-center hover:text-white transition-colors" data-id="element-35" data-mp="3gbijyk51v9y4">
                <PhoneIcon className="w-4 h-4 mr-3 text-gray-500" data-id="element-36" data-mp="3q8mz400ha55f" />
                (702) 213-4801
              </a>
              <a href="mailto:Results@GetAdROI.com" className="flex items-center hover:text-white transition-colors" data-id="element-37" data-mp="82ienymgqkhh">
                <MailIcon className="w-4 h-4 mr-3 text-gray-500" data-id="element-38" data-mp="31up7hdvubpd" />
                Results@GetAdROI.com
              </a>
              <div className="flex items-start" data-id="element-39" data-mp="ctqrz5qwypzx">
                <MapPinIcon className="w-4 h-4 mr-3 text-gray-500 mt-1 flex-shrink-0" data-id="element-40" data-mp="cu8tohwchwf8" />
                <span data-id="element-41" data-mp="quji7ea6myx8">
                  Las Vegas, NV
                  <br data-id="element-42" data-mp="mrwrjgp8zk1m" />
                  Serving Clients Nationwide
                </span>
              </div>
            </div>
          </div>

          {/* Services */}
          <div data-id="element-43" data-mp="twxtbfc15kby">
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-44" data-mp="tta0kieet1ya">
              Services
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-45" data-mp="13sr1ynmmotog">
              <li data-id="element-46" data-mp="13rzi2a2e8ke0">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-47" data-mp="13rfykox3hnxv">
                  Search Engine Optimization
                </a>
              </li>
              <li data-id="element-48" data-mp="1ckt20kssc7y7">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-49" data-mp="1clcma85wr8fe">
                  Pay-Per-Click Advertising
                </a>
              </li>
              <li data-id="element-50" data-mp="1mjihy814fibt">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-51" data-mp="1ml3chxnfr19o">
                  Web Design & Development
                </a>
              </li>
              <li data-id="element-52" data-mp="3obexrtubnece">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-53" data-mp="3oc6rt089t40k">
                  CRM Implementation
                </a>
              </li>
              <li data-id="element-54" data-mp="3tc2v0x958rf2">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-55" data-mp="2aevfvyawhy8f">
                  Conversion Rate Optimization
                </a>
              </li>
              <li data-id="element-56" data-mp="25n3u012owgom">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-57" data-mp="21mtg828nolz7">
                  Social Media Marketing
                </a>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div data-id="element-58" data-mp="2tdpsp1qt0oly">
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-59" data-mp="2te9e4sfnxv4q">
              Company
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-60" data-mp="2pcw6cct0fhv6">
              <li data-id="element-61" data-mp="2kd1f285boq9l">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-62" data-mp="2kci8top1bqbe">
                  About Us
                </a>
              </li>
              <li data-id="element-63" data-mp="2fdymvoafyej1">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-64" data-mp="2fgkol7anhztc">
                  Our Process
                </a>
              </li>
              <li data-id="element-65" data-mp="13y042spgoe4m">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-66" data-mp="13xgohinaa1tr">
                  Case Studies
                </a>
              </li>
              <li data-id="element-67" data-mp="2wm7md3irci3t">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-68" data-mp="2wmpouhw0jsk6">
                  Careers
                </a>
              </li>
              <li data-id="element-69" data-mp="2iww0s1sc1cbi">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-70" data-mp="2it89zae9v40h">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div data-id="element-71" data-mp="3flbrw2b3btqq">
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-72" data-mp="3fl248ldipyo7">
              Resources
            </h4>
            <ul className="space-y-3 text-sm mb-6" data-id="element-73" data-mp="31khknmzs3ytn">
              <li data-id="element-74" data-mp="36kndv7lp5tdu">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-75" data-mp="36k45ahhxshch">
                  Marketing Blog
                </a>
              </li>
              <li data-id="element-76" data-mp="1q52mwgzqx2xh">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-77" data-mp="1q8qehalmrf9k">
                  ROI Calculator
                </a>
              </li>
              <li data-id="element-78" data-mp="1nkwjcaf1nehg">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-79" data-mp="1nkedqn6hrnwv">
                  Free SEO Audit
                </a>
              </li>
              <li data-id="element-80" data-mp="1wmdudedlgpza">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-81" data-mp="1wmw1j61soolz">
                  Help Center
                </a>
              </li>
            </ul>
            <h4 className="text-white font-bold mb-4 uppercase tracking-wider text-sm" data-id="element-82" data-mp="13xyi2zluklrn">
              Follow Us
            </h4>
            <div className="flex space-x-4" data-id="element-83" data-mp="zx682455icub">
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-84" data-mp="zy7v76zfypse">
                <FacebookIcon className="w-5 h-5" data-id="element-85" data-mp="18xbeoc2it77f" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-86" data-mp="18uyq3g29byle">
                <TwitterIcon className="w-5 h-5" data-id="element-87" data-mp="g8xhfyj9aewx" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-88" data-mp="g6jnxu485arh">
                <InstagramIcon className="w-5 h-5" data-id="element-89" data-mp="2l96ti0bkqurk" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-90" data-mp="2l7dqqw430uou">
                <LinkedinIcon className="w-5 h-5" data-id="element-91" data-mp="2uzt7jq3n7d85" />
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center text-xs text-gray-500" data-id="element-92" data-mp="1xd2urr7hqauy">
          <p data-id="element-93" data-mp="22cypt0y7mryd">
            &copy; {new Date().getFullYear()} AdROI Marketing & Conversions. All
            rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-94" data-mp="2bc28i3tgt5cc">
            <a href="#" className="hover:text-white transition-colors" data-id="element-95" data-mp="2b9fzdzqxehs0">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-96" data-mp="3mqpigl6577ss">
              Terms of Service
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-97" data-mp="1b3vrd1edis8s">
              Cookie Policy
            </a>
          </div>
        </div>
      </div>
    </footer>;
}